export default [
  {
    path: "discounts",
    name: "discounts",
    component: (): Promise<any> => import(/* webpackChunkName: "webmaster:domains" */ "@/views/Webmaster/DiscountsView.vue")
  }
];
